import { apiClient as baseApiClient } from '#/api/client.tsx';
import type { HighwayMaintenanceFeeTicket } from '../model';

const cockpitApiClient = baseApiClient.create({
  baseURL: `${import.meta.env.VITE_BASE_URL}/cockpit/auto-pay`,
});

const ENROLLMENT_BASE = '/highway-maintenance-fee-auto-pay-enrollments';

type YYYYMMDD = string;
type ISODateTime = string;

type ScheduleEnrollmentsBody = {
  scheduledDate: YYYYMMDD;
};

export enum ScheduledStateEnum {
  SCHEDULED = 'SCHEDULED',
  EXECUTED = 'EXECUTED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

type ScheduleEnrollmentsResponse = {
  id: string;
  hmfAutoPayEnrollmentId: HighwayMaintenanceFeeTicket['hmfAutoPayEnrollmentId'];
  scheduledDate: YYYYMMDD;
  state: ScheduledStateEnum;
  operator: string;
  executedTicketId: HighwayMaintenanceFeeTicket['id'];
  reason: string;
  createDateTime: ISODateTime;
  updateDateTime: ISODateTime;
};

export const scheduleEnrollments = (
  enrollmentId: HighwayMaintenanceFeeTicket['hmfAutoPayEnrollmentId'],
  body: ScheduleEnrollmentsBody,
) => {
  return cockpitApiClient
    .post<{
      data: ScheduleEnrollmentsResponse;
    }>(`${ENROLLMENT_BASE}/${enrollmentId}/ticket-schedules`, body)
    .then((res) => res.data.data);
};

type DeleteScheduleResponse = {
  id: string;
  state: ScheduledStateEnum;
  reason: string;
  updateDateTime: ISODateTime;
};

export const deleteScheduledEnrollments = ({
  enrollmentId,
  scheduleId,
}: {
  enrollmentId: HighwayMaintenanceFeeTicket['hmfAutoPayEnrollmentId'];
  scheduleId: string;
}) => {
  return cockpitApiClient
    .delete<{
      data: DeleteScheduleResponse;
    }>(`${ENROLLMENT_BASE}/${enrollmentId}/ticket-schedules/${scheduleId}`)
    .then((res) => res.data.data);
};
